import { render, staticRenderFns } from "./materConvert.vue?vue&type=template&id=48cbaab8&"
import script from "./materConvert.vue?vue&type=script&lang=js&"
export * from "./materConvert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports